export type ConfigEnv = {
  eStreamUrl: {
    stream: string;
    baseUrl: string;
  };
  ersteMarketUrl: string;
  env: string;
  usUrl: {
    base: string;
    events: string;
    instrument: string;
    notification: string;
    oms: string;
    partnerData: string;
    session: string;
    userSettings: string;
    priceAlert: string;
    watchList: string;
    positions: string;
    consent: string;
    estream: string;
    userFeedback: string;
    account: string;
    currency: string;
    market: string;
    payment: string;
  };
  sso: {
    clientSecret?: string;
    discoveryUrl: string;
    clientId: string;
    redirectUri: string;
  };
  appDomain: string;
  links?: {
    registration: string;
    contact: string;
    legal: string;
    technical: string;
    currencyExchange: string;
    oldNetbroker: string;
  };
  featureFlags: {
    isOrderCurrencyExchangeEnabled: string; // 'True' or 'False'
    isHistoricalPortfolioValueEnabled: string; // 'True' or 'False'
    isPortfolioNewDesignEnabled: string; // 'True' or 'False'
    isCashActionEnabled: string; // 'True' or 'False'
    isMobileAppBannerEnabled: string; // 'True' or 'False'
    isNewOrderFormEnabled: string; // 'True' or 'False'
    isUserFeedbackEnabled: string; // 'True' or 'False'
  };
};

// used in tests
export const dummyConfig: ConfigEnv = {
  eStreamUrl: {} as any,
  usUrl: {} as any,
  sso: {} as any,
  links: {} as any,
  featureFlags: {} as any,
} as any;
